import React from 'react';
import { View, Text, Image, StyleSheet } from 'react-native';
import { Card } from '../../cards';
import { SquareButton, ButtonRow, ActionButton } from '../../JCButtons';
import colors from '../../../config/colors';
import routes from '../../../navigation/routes';

/**
 * ClimatePalView - Device view for Climate Pal (deviceType "3")
 * Temperature and humidity sensor
 */
function ClimatePalView({
    data,
    deviceData,
    battEnable,
    newSettings5,
    auth,
    setVisibleTriggerF,
    setVisibleTrigger2,
    navigation,
    route,
    setUpdateNeededHigherLevel,
}) {
    const deviceInfo = data?.[0];
    const realtimeData = deviceInfo?.realtimeData ? JSON.parse(deviceInfo.realtimeData) : {};

    return (
        <>
            {/* Device Metrics Card */}
            <Card>
                <View style={styles.metricsContainer}>
                    {/* Temperature - large display */}
                    <View style={styles.tempDisplay}>
                        <Text style={styles.tempValue}>
                            {deviceData?.temperature || realtimeData?.T}
                        </Text>
                        <Text style={styles.tempLabel}>Temperature</Text>
                    </View>

                    <MetricRow
                        label="Humidity"
                        value={`${deviceData?.humidity || realtimeData?.H}%`}
                    />

                    {battEnable && (
                        <MetricRow
                            label="Battery"
                            value={`${deviceData?.battery || realtimeData?.B}%`}
                        />
                    )}
                </View>

                {/* Device Icon */}
                <Image
                    source={require('../../../assets/cpIcon.png')}
                    style={styles.deviceIcon}
                />
            </Card>

            {/* Actions */}
            <Card style={styles.actionsCard}>
                <Text style={styles.sectionTitle}>Device Management</Text>
                <ButtonRow>
                    <SquareButton
                        title="View/Change Settings"
                        onPress={() => navigation.navigate(routes.CHANGESETTINGSCLIMATEPAL, { item: route.params.item, changedDevices: setUpdateNeededHigherLevel })}
                        icon="cogs"
                        color={colors.primary}
                        disabled={auth.userPermissions.role !== 'admin'}
                    />
                    <SquareButton
                        title="View Event History"
                        onPress={() => navigation.navigate(routes.DASHBOARD, { item: route.params.item, changedDevices: setUpdateNeededHigherLevel })}
                        icon="history"
                        color={colors.primary}
                    />
                    <SquareButton
                        title="More Device Details"
                        onPress={() => navigation.navigate(routes.PRESENTSETTINGS, { item: route.params.item })}
                        icon="search-plus"
                        color={colors.primary}
                    />
                </ButtonRow>
                {newSettings5 && (
                    <ButtonRow>
                        <SquareButton
                            title="Update Firmware"
                            onPress={() => setVisibleTriggerF(true)}
                            icon="cloud-upload"
                            color={colors.primary}
                        />
                        <SquareButton
                            title="Deregister Device"
                            onPress={() => setVisibleTrigger2(true)}
                            icon="trash"
                            color={colors.primary}
                            disabled={auth.userPermissions.role !== 'admin'}
                        />
                    </ButtonRow>
                )}
                {!newSettings5 && (
                    <ButtonRow>
                        <ActionButton
                            title="Deregister Device"
                            onPress={() => setVisibleTrigger2(true)}
                            icon="trash"
                            color={colors.primary}
                            disabled={auth.userPermissions.role !== 'admin'}
                        />
                    </ButtonRow>
                )}
            </Card>
        </>
    );
}

function MetricRow({ label, value }) {
    return (
        <View style={styles.metricRow}>
            <Text style={styles.metricLabel}>{label}</Text>
            <Text style={styles.metricValue}>{value}</Text>
        </View>
    );
}

const styles = StyleSheet.create({
    metricsContainer: {
        position: 'relative',
        paddingBottom: 35, // Make room for absolute-positioned device icon
    },
    metricRow: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        alignItems: 'center',
        paddingVertical: 6,
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
    },
    metricLabel: {
        fontWeight: 'bold',
        color: colors.dark,
        fontSize: 14,
    },
    metricValue: {
        color: colors.medium,
        fontSize: 14,
    },
    tempDisplay: {
        alignItems: 'center',
        paddingVertical: 16,
        borderBottomWidth: 1,
        borderBottomColor: '#f0f0f0',
    },
    tempValue: {
        fontSize: 48,
        fontWeight: 'bold',
        color: colors.primary,
    },
    tempLabel: {
        fontSize: 14,
        color: colors.medium,
        marginTop: 4,
    },
    deviceIcon: {
        position: 'absolute',
        bottom: 8,
        right: 8,
        width: 80,
        height: 25,
    },
    actionsCard: {
        paddingVertical: 12,
    },
    sectionTitle: {
        fontSize: 16,
        fontWeight: 'bold',
        color: colors.dark,
        marginBottom: 8,
        textAlign: 'center',
    },
});

export default ClimatePalView;
